import _ from 'lodash'
import { building } from '@/constants/building.js'
// 建物情報
const Building = {
  namespaced: true,
  state: {
    // 建物項目
    building: _.cloneDeep(building),
    // 物件登録/編集に必要な項目
    item: {
      prefList: [],
      shikuList: [],
      chosonList: [],
      azaList: [],
      address: '',
      loadMapAddress: false,
      loadMapLatLon: false,
      lineList: [],
      stationList1: [],
      stationList2: [],
      stationList3: [],
      stationList4: [],
    },
  },
  getters: {
    getBuilding: state => {
      return state.building
    },
    getBuildingImages: state => {
      return state.building.rent_b_images
    },
    getBuildingId: state => {
      return state.building.rent_b_regulars.building_id
    },
    getItem: state => {
      return state.item
    },
  },
  mutations: {
    setBuilding(state, building) {
      state.building = building
    },
    setItem(state, item) {
      state.item = item
    },
  },
  actions: {
    reset({ commit }) {
      commit('setBuilding', building)
    },
  },
}

export default Building
